// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { postExpectationsClient } from "../../../app/rpc/client"
import * as Slice from "../slices/stats"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import {
  ListMemberExpectationsRequest
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"
import { Date } from "../../../generated/google/type/date_pb"
import { showSnackBar } from "../../snackbar/actions"

type DeleteLeaveRpc = (payload: Actions.DeleteLeavePayload) => Observable<Empty>

export const deleteLeave = (deleteLeaveRpc: DeleteLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.deleteLeave.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(deleteLeaveRpc),
          mergeMap(_ => {
            const date = new Date()
              .setYear(action.payload.date.year)
              .setMonth(action.payload.date.month)
              .setDay(action.payload.date.day)
            const listMemberExpectationsRequest = new ListMemberExpectationsRequest()
              .setSiteId(action.payload.deleteLeaveRequest.getSiteId())
              .setMembershipId(action.payload.membershipId)
              .setStartDate(date)
              .setEndDate(date)
            return concat(
              of(Slice.deleteLeave(action.payload.deleteLeaveRequest.getId())),
              of(Actions.refreshMemberExpectations(listMemberExpectationsRequest)),
            )
          }),
          catchError(() => of(showSnackBar({
            message: t({ id: "msg_delete_leave_failed", message: "Failed to delete leave. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const deleteLeaveRpc = (payload: Actions.DeleteLeavePayload): Observable<Empty> =>
  grpc(() => postExpectationsClient.deleteLeave(payload.deleteLeaveRequest, null))

export default deleteLeave(deleteLeaveRpc)
